/**
 * Prefixo das linhas do tempo de atendimento, num módulo sem dependências:
 * quem só invalida (o realtime, o "tentar de novo" da mídia) não puxa a tela
 * inteira — nem fecha ciclo com ela, que importa a bolha de mídia do chat.
 */
export const TIMELINE_KEY = ['erp', 'tickets', 'timeline'] as const;
